import React from "react";
import { Pivot as Hamburger } from "hamburger-react";
import { Link } from "gatsby";
import { useState, useEffect } from "react";

const Header = ({ mobileNav, setMobilenav, darkTheme, header_options }) => {
  const [pageScroll, setPageScroll] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", function () {
        if (
          window.scrollY > header_options?.nav_color_height &&
          header_options?.bg_transparent
        ) {
          setPageScroll(true);
        } else {
          setPageScroll(false);
        }
      });
    }
  }, []);

  const menuToggle = () => {
    setMobilenav(!mobileNav);
  };
  const navActiveHandler = (value) => {
    return typeof window !== "undefined" && window.location.pathname === value
      ? `underline text-primary-red`
      : header_options?.bg_transparent &&
        !pageScroll &&
        !header_options?.remove_background
      ? "underline text-light-beige"
      : "underline text-primary-red";
  };
  return (
    <>
      <div
        className={`sticky top-0 z-30
       ${
         darkTheme
           ? "bg-light-black"
           : (header_options?.bg_transparent && !pageScroll && !mobileNav) ||
             (header_options?.remove_background && !pageScroll)
           ? "bg-transparent"
           : "bg-light-beige"
       }`}
      >
        <div>
          <header className="container mx-auto header py-5 lg:py-10 px-3 lg:px-17 lg:border-none border-b border-gray-400">
            <div className="flex justify-between items-start xl:items-center container mx-auto py-0 px-4 lg:px-0">
              <div
                className={`h-10 w-36 md:mr-6 ${
                  darkTheme
                    ? "text-light-yellow"
                    : header_options?.bg_transparent &&
                      !pageScroll &&
                      !mobileNav &&
                      !header_options?.remove_background
                    ? "text-light-beige"
                    : "text-primary-red"
                }`}
              >
                <Link to="/" aria-label="Go to homepage">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 153 41"
                    fill="currentColor"
                  >
                    <path
                      d="M16.352 40H22.092L13.86 19.056H8.232L0 40H5.712L7.112 36.304H14.952L16.352 40ZM8.904 31.6L11.032 25.972L13.16 31.6H8.904ZM31.941 35.52H29.085C28.749 35.52 28.497 35.436 28.301 35.212C28.077 35.016 27.993 34.764 27.993 34.428V28.184H31.381V23.704H27.993V18.72L22.841 20.68V23.704H20.265V28.184H22.841V35.156C22.841 36.64 23.261 37.816 24.157 38.684C25.053 39.58 26.229 40 27.685 40H31.381L31.941 35.52ZM44.0269 35.52H41.1709C40.8349 35.52 40.5829 35.436 40.3869 35.212C40.1629 35.016 40.0789 34.764 40.0789 34.428V28.184H43.4669V23.704H40.0789V18.72L34.9269 20.68V23.704H32.3509V28.184H34.9269V35.156C34.9269 36.64 35.3469 37.816 36.2429 38.684C37.1389 39.58 38.3149 40 39.7709 40H43.4669L44.0269 35.52ZM57.1423 28.184L56.5823 23.704H54.1183C53.3623 23.704 52.6903 23.928 52.1023 24.348C51.5143 24.768 51.0943 25.328 50.8423 26.028L50.5623 23.704H45.9703V40H51.1223V32.44C51.1223 31.152 51.4023 30.116 51.9903 29.332C52.5783 28.576 53.4183 28.184 54.4823 28.184H57.1423ZM59.1299 21.548C59.7179 22.108 60.4739 22.388 61.3979 22.388C62.2939 22.388 63.0499 22.108 63.6379 21.548C64.2259 20.988 64.5339 20.288 64.5339 19.392C64.5339 18.524 64.2259 17.796 63.6379 17.236C63.0499 16.676 62.2939 16.396 61.3979 16.396C60.4739 16.396 59.7179 16.676 59.1299 17.236C58.5419 17.796 58.2619 18.524 58.2619 19.392C58.2619 20.288 58.5419 20.988 59.1299 21.548ZM63.9739 40V23.704H58.8219V40H63.9739ZM79.4909 24.432C78.3989 23.732 77.1669 23.368 75.7949 23.368C75.0389 23.368 74.3389 23.536 73.6669 23.816C72.9949 24.124 72.4349 24.544 71.9309 25.076V19.056H66.7789V40H71.3429L71.5949 38.208C72.0709 38.88 72.6869 39.412 73.4149 39.776C74.1429 40.168 74.9269 40.336 75.7949 40.336C77.1669 40.336 78.3989 40 79.4909 39.3C80.5549 38.6 81.3949 37.592 82.0109 36.304C82.6269 35.016 82.9349 33.532 82.9349 31.852C82.9349 30.172 82.6269 28.688 82.0109 27.4C81.3949 26.112 80.5549 25.132 79.4909 24.432ZM76.9709 34.68C76.4109 35.352 75.7109 35.688 74.8149 35.688C73.9189 35.688 73.1909 35.352 72.6869 34.652C72.1829 33.98 71.9309 33.028 71.9309 31.852C71.9309 30.676 72.1829 29.752 72.6869 29.052C73.1909 28.38 73.9189 28.016 74.8149 28.016C75.7109 28.016 76.4109 28.38 76.9709 29.052C77.5029 29.724 77.7829 30.676 77.7829 31.852C77.7829 33.056 77.5029 34.008 76.9709 34.68ZM99.7231 23.704H94.5711V33.028C94.5711 33.812 94.3471 34.456 93.8991 34.96C93.4511 35.464 92.8351 35.688 92.0791 35.688C91.3791 35.688 90.8191 35.492 90.3991 35.044C89.9791 34.596 89.7831 34.008 89.7831 33.252V23.704H84.6311V34.372C84.6311 35.576 84.8831 36.64 85.3871 37.536C85.8911 38.432 86.5631 39.132 87.4591 39.608C88.3551 40.112 89.3631 40.336 90.5111 40.336C91.4351 40.336 92.2751 40.14 93.0311 39.692C93.7871 39.244 94.4031 38.628 94.8791 37.844L95.1311 40H99.7231V23.704ZM112.933 35.52H110.077C109.741 35.52 109.489 35.436 109.293 35.212C109.069 35.016 108.985 34.764 108.985 34.428V28.184H112.373V23.704H108.985V18.72L103.833 20.68V23.704H101.257V28.184H103.833V35.156C103.833 36.64 104.253 37.816 105.149 38.684C106.045 39.58 107.221 40 108.677 40H112.373L112.933 35.52ZM129.639 35.044L124.851 34.148C124.655 34.68 124.319 35.1 123.843 35.38C123.367 35.688 122.807 35.828 122.163 35.828C121.267 35.828 120.567 35.576 120.007 35.044C119.447 34.512 119.055 33.812 118.887 32.972H129.387C129.499 32.188 129.583 31.572 129.583 31.068C129.583 29.584 129.247 28.268 128.575 27.092C127.903 25.916 126.979 25.02 125.803 24.348C124.627 23.704 123.283 23.368 121.771 23.368C120.203 23.368 118.803 23.76 117.627 24.516C116.423 25.3 115.499 26.336 114.855 27.624C114.211 28.912 113.903 30.34 113.903 31.852C113.903 33.392 114.239 34.82 114.939 36.108C115.611 37.396 116.591 38.432 117.851 39.188C119.083 39.972 120.539 40.336 122.163 40.336C124.011 40.336 125.663 39.888 127.063 38.936C128.463 38.012 129.303 36.724 129.639 35.044ZM120.063 28.1C120.567 27.708 121.183 27.512 121.883 27.512C122.611 27.512 123.227 27.736 123.731 28.128C124.235 28.52 124.487 29.052 124.543 29.696H118.999C119.195 29.024 119.559 28.492 120.063 28.1ZM134.8 39.664C135.892 40.112 137.096 40.336 138.44 40.336C139.728 40.336 140.904 40.112 141.968 39.664C143.004 39.216 143.816 38.572 144.432 37.732C145.02 36.892 145.328 35.968 145.328 34.904C145.328 33.588 145.02 32.552 144.404 31.824C143.788 31.096 143.06 30.592 142.22 30.312C141.38 30.032 140.344 29.752 139.084 29.528C138.048 29.36 137.32 29.164 136.9 28.996C136.452 28.828 136.256 28.548 136.256 28.156C136.256 27.876 136.396 27.624 136.676 27.456C136.956 27.288 137.32 27.204 137.768 27.204C138.328 27.204 138.832 27.372 139.252 27.708C139.644 28.044 139.952 28.492 140.148 29.052L145.104 28.352C144.936 27.428 144.516 26.588 143.844 25.804C143.172 25.048 142.304 24.46 141.268 24.012C140.232 23.592 139.14 23.368 137.964 23.368C136.676 23.368 135.5 23.592 134.492 24.04C133.484 24.488 132.672 25.132 132.112 25.916C131.552 26.728 131.272 27.652 131.272 28.688C131.272 29.976 131.552 30.956 132.14 31.628C132.7 32.328 133.4 32.804 134.184 33.084C134.968 33.364 135.976 33.588 137.208 33.784C138.272 33.98 139.056 34.176 139.56 34.372C140.064 34.568 140.316 34.904 140.316 35.408C140.316 35.744 140.148 35.996 139.868 36.192C139.56 36.388 139.14 36.472 138.636 36.472C137.936 36.472 137.32 36.304 136.816 35.94C136.284 35.604 135.948 35.1 135.78 34.484L130.908 35.044C131.02 36.08 131.44 37.004 132.112 37.788C132.784 38.6 133.68 39.216 134.8 39.664Z"
                      fill="currentColor"
                    />
                    <path
                      d="M32.429 2.71998V0.0319824H21.869V2.71998H25.629V12H28.669V2.71998H32.429ZM40.376 2.91198C39.864 2.63998 39.288 2.49598 38.648 2.49598C38.168 2.49598 37.72 2.60798 37.32 2.79998C36.92 3.00798 36.584 3.29598 36.328 3.66398V0.0319824H33.384V12H36.328V6.67198C36.328 6.22398 36.456 5.87198 36.712 5.58398C36.968 5.29598 37.304 5.15198 37.752 5.15198C38.136 5.15198 38.456 5.27998 38.696 5.53598C38.936 5.79198 39.064 6.12798 39.064 6.54398V12H42.008V5.90398C42.008 5.23198 41.864 4.62398 41.576 4.11198C41.288 3.59998 40.888 3.19998 40.376 2.91198ZM52.1166 9.16798L49.3806 8.65598C49.2686 8.95998 49.0766 9.19998 48.8046 9.35998C48.5326 9.53598 48.2126 9.61598 47.8446 9.61598C47.3326 9.61598 46.9326 9.47198 46.6126 9.16798C46.2926 8.86398 46.0686 8.46398 45.9726 7.98398H51.9726C52.0366 7.53598 52.0846 7.18398 52.0846 6.89598C52.0846 6.04798 51.8926 5.29598 51.5086 4.62398C51.1246 3.95198 50.5966 3.43998 49.9246 3.05598C49.2526 2.68798 48.4846 2.49598 47.6206 2.49598C46.7246 2.49598 45.9246 2.71998 45.2526 3.15198C44.5646 3.59998 44.0366 4.19198 43.6686 4.92798C43.3006 5.66398 43.1246 6.47998 43.1246 7.34398C43.1246 8.22398 43.3166 9.03998 43.7166 9.77598C44.1006 10.512 44.6606 11.104 45.3806 11.536C46.0846 11.984 46.9166 12.192 47.8446 12.192C48.9006 12.192 49.8446 11.936 50.6446 11.392C51.4446 10.864 51.9246 10.128 52.1166 9.16798ZM46.6446 5.19998C46.9326 4.97598 47.2846 4.86398 47.6846 4.86398C48.1006 4.86398 48.4526 4.99198 48.7406 5.21598C49.0286 5.43998 49.1726 5.74398 49.2046 6.11198H46.0366C46.1486 5.72798 46.3566 5.42398 46.6446 5.19998Z"
                      fill="currentColor"
                    />
                    <path
                      d="M149.277 23.6269V23.0149H147.09V23.6269H147.837V25.4359H148.539V23.6269H149.277ZM152.409 25.4359V23.0149H151.401L150.951 24.5449L150.492 23.0149H149.475V25.4359H150.186V24.1399L150.618 25.4359H151.266L151.698 24.1309V25.4359H152.409Z"
                      fill="currentColor"
                    />
                  </svg>
                </Link>
              </div>
              <div className="desktop-navigation hidden lg:block">
                <nav>
                  <ul className="flex flex-wrap">
                    <li className="mr-6 mb-4 xl:mb-0">
                      <Link
                        to="/consulting"
                        className={`hover:no-underline hover:text-black ${
                          darkTheme
                            ? "hover:text-primary-red"
                            : header_options?.bg_transparent &&
                              !pageScroll &&
                              !header_options?.remove_background
                            ? "hover:text-light-beige"
                            : " hover:text-black"
                        } ${navActiveHandler("/consulting")}`}
                      >
                        For Teams
                      </Link>
                    </li>
                    <li className="mr-6 mb-4 xl:mb-0">
                      <Link
                        to="/for-individuals"
                        className={`hover:no-underline hover:text-black ${
                          darkTheme
                            ? "hover:text-primary-red"
                            : header_options?.bg_transparent &&
                              !pageScroll &&
                              !header_options?.remove_background
                            ? "hover:text-light-beige"
                            : " hover:text-black"
                        } ${navActiveHandler("/for-individuals")}`}
                      >
                        For Individuals
                      </Link>
                    </li>
                    <li className="mr-6 mb-4 xl:mb-0">
                      <Link
                        className={`hover:no-underline hover:text-black ${
                          darkTheme
                            ? "hover:text-primary-red"
                            : header_options?.bg_transparent &&
                              !pageScroll &&
                              !header_options?.remove_background
                            ? "hover:text-light-beige"
                            : " hover:text-black"
                        } ${navActiveHandler("/assessment-tool")}`}
                        to="/assessment-tool"
                      >
                        Our Assessments
                      </Link>
                    </li>
                    <li className="mr-6 mb-4 xl:mb-0">
                      <Link
                        className={`hover:no-underline hover:text-black ${
                          darkTheme
                            ? "hover:text-primary-red"
                            : header_options?.bg_transparent &&
                              !pageScroll &&
                              !header_options?.remove_background
                            ? "hover:text-light-beige"
                            : " hover:text-black"
                        } ${navActiveHandler("/author")}`}
                        to="/author"
                      >
                        About Us
                      </Link>
                    </li>

                    <li className="mr-6 mb-4 xl:mb-0">
                      <Link
                        className={` hover:no-underline hover:text-black ${
                          darkTheme
                            ? "hover:text-primary-red"
                            : header_options?.bg_transparent &&
                              !pageScroll &&
                              !header_options?.remove_background
                            ? "hover:text-light-beige"
                            : " hover:text-black"
                        } ${navActiveHandler("/blog")}`}
                        to="/contact"
                      >
                        Get in Touch
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="hidden lg:block">
                <a href="https://hub.theattributes.com/" target="_blank">
                  <button
                    className={`transition duration-300 ease-in-out  px-7 py-4 rounded-full cursor-pointer ${
                      darkTheme
                        ? "bg-primary-red hover:bg-primary-red text-white border border-transparent"
                        : header_options?.bg_transparent &&
                          !pageScroll &&
                          !header_options?.remove_background
                        ? "bg-primary-red hover:bg-transparent text-white border  hover:border-white border-transparent"
                        : "bg-primary-red hover:bg-black text-white border border-transparent"
                    }`}
                  >
                    Take Our Assessments
                  </button>
                </a>
              </div>
              <div
                className={`block lg:hidden ${
                  header_options?.bg_transparent && !pageScroll
                    ? `${mobileNav ? "text-black" : "text-white"}`
                    : ""
                }`}
                onClick={() => {
                  menuToggle();
                }}
                onKeyPress={() => {
                  menuToggle();
                }}
                role="button"
                tabIndex="0"
              >
                <div
                  class="hamburger-react"
                  aria-expanded="false"
                  role="button"
                  tabindex="0"
                  style={{
                    cursor: "pointer",
                    height: "48px",
                    position: "relative",
                    transition: "0.4s cubic-bezier(0, 0, 0, 1)",
                    userSelect: "none",
                    width: "48px",
                    outline: "none",
                    transform: "none",
                  }}
                >
                  <div
                    style={{
                      transition:
                        "0.2s cubic-bezier(0, 0, 0, 1) 0.2s; transform: none;",
                    }}
                  >
                    <div
                      style={{
                        background: "currentcolor",
                        height: "3px",
                        left: "8px",
                        position: "absolute",
                        width: "32px",
                        top: "17px",
                        transition: "0.2s cubic-bezier(0, 0, 0, 1)",
                        transform: "none;",
                      }}
                    ></div>
                  </div>
                  <div
                    style={{
                      transition:
                        "0.2s cubic-bezier(0, 0, 0, 1) 0.2s; transform: none;",
                    }}
                  >
                    <div
                      style={{
                        background: "currentcolor",
                        height: "3px",
                        left: "8px",
                        position: "absolute",
                        width: "32px",
                        top: "29px",
                        transition: "0.2s cubic-bezier(0, 0, 0, 1)",
                        transform: "none;",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
    </>
  );
};
export default Header;
